/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SearchX = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.91956 1.45038C14.4258 1.45038 18.0787 5.10338 18.0787 9.60956C18.0787 11.5926 17.3702 13.4095 16.194 14.8234L18.6393 17.2687C18.932 17.5616 18.9321 18.0364 18.6393 18.3293C18.3464 18.6219 17.8716 18.6219 17.5787 18.3293L15.1334 15.884C13.7195 17.0602 11.9026 17.7687 9.91956 17.7687C5.41336 17.7687 1.76038 14.1158 1.76038 9.60956C1.76046 5.10342 5.41341 1.45044 9.91956 1.45038ZM9.91956 2.95038C6.24183 2.95044 3.26046 5.93184 3.26038 9.60956C3.26038 13.2873 6.24178 16.2687 9.91956 16.2687C13.5974 16.2687 16.5787 13.2874 16.5787 9.60956C16.5787 5.93181 13.5973 2.95038 9.91956 2.95038ZM11.7623 6.70721C12.0552 6.41432 12.53 6.41432 12.8229 6.70721C13.1154 7.00014 13.1156 7.475 12.8229 7.76776L10.9801 9.60956L12.8229 11.4523C13.1153 11.7452 13.1155 12.2201 12.8229 12.5129C12.5301 12.8055 12.0552 12.8053 11.7623 12.5129L9.91956 10.6701L8.07776 12.5129C7.78489 12.8054 7.30903 12.8055 7.01624 12.5129C6.72379 12.2202 6.72403 11.7452 7.01624 11.4523L8.85901 9.60956L7.01624 7.76776C6.72366 7.47504 6.72394 7.00011 7.01624 6.70721C7.30913 6.41432 7.78487 6.41432 8.07776 6.70721L9.91956 8.54901L11.7623 6.70721Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default SearchX;
